import { SelectContentProps } from 'components/ui/Forms';
import { DriverDocType } from 'interfaces/driver-doc-types';
import { apiHub } from 'services';

export const useHubVehicleDocTypes = () => {
  const fetchDocTypes = async () => {
    const { data } = await apiHub.get<DriverDocType[]>(`/vehicle-doc-type`);

    const comboOptions: SelectContentProps[] = data.map((docType: any) => ({
      name: docType.name,
      value: docType.id,
    }));

    return { comboOptions, data }
  };

  return { fetchDocTypes };
};
